class FilterDropdown extends HTMLElement {
  constructor() {
    super();

    this.tempHTMLContainer = null;
    this.filterTypes = this.querySelectorAll(".filter__type");
    this.filterValues = this.querySelectorAll(".filter__value a");
    this.activeFilters = [];
    this.removeAllBtn = this.querySelector("#removeFilters");
    this.collUrl = this.dataset.collection;
    this.currentProductGrid = this.closest(".collection-grid-section").querySelector(
      "#CollectionProductGrid"
    );

    // to sync with mobile filter
    this.mobileFilter = this.parentElement.querySelector("filter-dropdown-mob");

    this.init();
  }

  init() {
    this.filterTypes.forEach((filtercat) => {
      filtercat.addEventListener("click", this.filterTabClick.bind(this, filtercat));
    });
    this.filterValues.forEach((filter) => {
      filter.addEventListener("click", this.filterClick.bind(this, filter));
    });
    this.removeAllBtn
      ? this.removeAllBtn.addEventListener("click", this.clearFilters.bind(this))
      : "";
  }

  renderLoading() {
    return `
      <div class="collection__loading">
        <?xml version="1.0" encoding="utf-8"?>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: transparent; display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <circle cx="50" cy="50" fill="none" stroke="#008FBB" stroke-width="7" r="30" stroke-dasharray="141.37166941154067 49.12388980384689">
          <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.7692307692307692s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
        </circle>
        <!-- [ldio] generated by https://loading.io/ --></svg>
      </div>
    `;
  }

  filterTabClick(filtercat) {
    filtercat.classList.toggle("closed");
  }

  filterClick(filter) {
    const activeFilter = filter.closest(".filter__values").querySelector(".filteractive");
    if (activeFilter) {
      activeFilter.classList.remove("filteractive");
    }
    if (!Object.is(activeFilter, filter)) {
      filter.classList.add("filteractive");
    }

    // execute filtering action
    this.getProductListing();
  }

  clearFilters() {
    this.querySelectorAll(".filteractive").forEach((el) => el.classList.remove("filteractive"));
    this.removeAllBtn.classList.add("cleared");

    // execute filtering action
    this.getProductListing();
  }

  async getProductListing() {
    // Prompt loading screen
    if (this.currentProductGrid) {
      this.currentProductGrid.innerHTML = this.renderLoading();
    }

    window.scrollTo({
      top: 0, // Scrolls to the top of the document
      behavior: "smooth", // Smooth scrolling
    });

    const valueContainers = Array.from(this.querySelectorAll(".filteractive"));
    const filterValues = valueContainers.map((container) => container.dataset.filterValue);
    this.activeFilters = filterValues;

    // sync mobile filter to desktop
    this.syncMobileFilter();

    // render/remove remove all filters button (on top of the filter container)
    console.log("filterValues: ", filterValues);
    console.log("filterValues.length: ", filterValues.length);

    filterValues && filterValues.length > 0
      ? this.removeAllBtn.classList.remove("cleared")
      : this.removeAllBtn.classList.add("cleared");

    try {
      const response = await fetch(`${this.collUrl}/${filterValues.join("+")}`);
      const collectionHTMLStr = await response.text();
      this.tempHTMLContainer = this.parseHTMLStr(collectionHTMLStr);
    } catch (err) {
      console.error(err);
    } finally {
      this.currentProductGrid.innerHTML = this.tempHTMLContainer.innerHTML;

      const loaderElements = document.querySelectorAll(".line-of-dots");
      loaderElements?.forEach((element) => {
        element.classList.remove("line-of-dots");
      });

      stampedInit(window, document);
    }
  }

  syncMobileFilter() {
    if (this.mobileFilter) {
      this.mobileFilter.activeFilters = this.activeFilters;
      this.mobileFilter.filterValues.forEach((filter) => {
        if (this.activeFilters.includes(filter.dataset.filterValue))
          filter.classList.add("filteractive");
        else filter.classList.remove("filteractive");
      });
    }
  }

  parseHTMLStr(htmlStr) {
    const container = document.createElement("div");
    container.innerHTML = htmlStr;

    return container.querySelector("#CollectionProductGrid");
  }
}

customElements.define("filter-dropdown", FilterDropdown);

class FilterDropdownMob extends FilterDropdown {
  constructor() {
    super();

    this.filterOverlay = this.querySelector(".filter__overlay");
    this.openingBtn = this.querySelector("#filterOpen");
    this.applyBtn = this.querySelector("#applyFilter");

    // to sync with desktop filter
    this.desktopFilter = this.parentElement.querySelector("filter-dropdown");

    this.mobinit();
  }

  mobinit() {
    this.openingBtn ? this.openingBtn.addEventListener("click", this.openFilter.bind(this)) : "";
    this.filterOverlay
      ? this.filterOverlay.addEventListener("click", this.closeFilter.bind(this))
      : "";
    this.applyBtn ? this.applyBtn.addEventListener("click", this.getProductListing.bind(this)) : "";
  }

  openFilter() {
    this.classList.add("filteropen");
  }
  closeFilter() {
    this.classList.remove("filteropen");
  }

  filterClick(filter) {
    const activeFilter = filter.closest(".filter__values").querySelector(".filteractive");
    if (activeFilter) {
      activeFilter.classList.remove("filteractive");
    }
    if (!Object.is(activeFilter, filter)) {
      filter.classList.add("filteractive");
    }
  }

  async getProductListing() {
    // Prompt loading screen
    if (this.currentProductGrid) {
      this.currentProductGrid.innerHTML = this.renderLoading();
    }

    window.scrollTo({
      top: 0, // Scrolls to the top of the document
      behavior: "smooth", // Smooth scrolling
    });

    const valueContainers = Array.from(this.querySelectorAll(".filteractive"));
    const filterValues = valueContainers.map((container) => container.dataset.filterValue);
    this.activeFilters = filterValues;

    // sync desktop filter to mobile
    this.syncDesktopFilter();

    // close the filter, and let user view the operation
    this.closeFilter();

    try {
      const response = await fetch(`${this.collUrl}/${filterValues.join("+")}`);
      const collectionHTMLStr = await response.text();
      this.tempHTMLContainer = this.parseHTMLStr(collectionHTMLStr);
    } catch (err) {
      console.error(err);
    } finally {
      this.currentProductGrid.innerHTML = this.tempHTMLContainer.innerHTML;

      const loaderElements = document.querySelectorAll(".line-of-dots");
      loaderElements?.forEach((element) => {
        element.classList.remove("line-of-dots");
      });

      stampedInit(window, document);
    }
  }

  syncDesktopFilter() {
    if (this.desktopFilter) {
      this.desktopFilter.activeFilters = this.activeFilters;
      this.desktopFilter.filterValues.forEach((filter) => {
        if (this.activeFilters.includes(filter.dataset.filterValue))
          filter.classList.add("filteractive");
        else filter.classList.remove("filteractive");
      });
    }
  }
}

customElements.define("filter-dropdown-mob", FilterDropdownMob);
